/**
 * While the next page loads, the page being left says so.
 *
 * Every link here is a full page load, and on a slow phone the old page stays on
 * screen for a second or two after the tap. The pressed look (assets/base.css,
 * "Press feedback on touch screens") ends when the finger lifts, so for that
 * stretch nothing shows the tap was taken.
 *
 * When a navigation to another page starts:
 *   - <html> gets `is-leaving`. In the app, which has no browser progress bar,
 *     base.css draws a thin bar along the top from 0.3s on.
 *   - the control that was pressed last gets `data-leaving`, which keeps its
 *     pressed look on touch screens.
 * Both are cleared if this page is shown again (restored from the browser's
 * page cache on Back), or after 8s if the page never left.
 */
(function () {
  // ponytail: Navigation API only (Chrome and Android WebView 102+, Safari 26.2+).
  // It is the one event that also sees navigations started by script, which is how
  // product cards open. Older browsers keep today's behaviour; a click listener on
  // links would be the fallback if they ever need covering.
  if (!window.navigation) return;

  var root = document.documentElement;
  var pressed = null;
  var pressedAt = 0;
  var timer = 0;

  function clear() {
    clearTimeout(timer);
    root.classList.remove('is-leaving');
    var held = document.querySelector('[data-leaving]');
    if (held) held.removeAttribute('data-leaving');
  }

  // A card is one tap target and dims as a whole, so it is held as a whole.
  document.addEventListener(
    'pointerdown',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      pressed =
        target &&
        (target.closest('.product-card, .resource-card') || target.closest("a, button, summary, [role='button']"));
      pressedAt = Date.now();
    },
    { capture: true, passive: true }
  );

  window.navigation.addEventListener('navigate', function (event) {
    var to = new URL(event.destination.url);
    // Not leaving: a history entry on this page (an open sheet, a filter), a
    // download, or a link another app takes (WhatsApp, phone, mail).
    if (event.destination.sameDocument || event.hashChange || event.downloadRequest !== null) return;
    if (to.origin !== location.origin) return;
    // The app opens checkout in its own sheet over this page, which stays put.
    if (window.includIsApp && /^\/(checkouts?(\/|$)|cart\/\d)/.test(to.pathname)) return;

    clear();
    root.classList.add('is-leaving');
    if (pressed && pressed.isConnected && Date.now() - pressedAt < 3000) pressed.setAttribute('data-leaving', '');
    timer = setTimeout(clear, 8000);
  });

  window.addEventListener('pageshow', clear);
})();
